import {
	AnimationEnum,
	BackgroundType,
	ConfigData,
	CornerRadiusMode,
	CountdownPosition,
	DisplayAt,
	TextAlignment,
	TimerMode,
	TimerPosition,
	TimerType,
} from '@/types';

export const DEFAULT_CONFIG: ConfigData = {
	enable_timer: true,
	name: '',
	priority: 1,
	timer_type: TimerType.BAR,
	template_id: null,
	display_at: DisplayAt.HOME,
	countdown_mode: 'start-to-finish',
	time_frame_type: 'days',
	interactivity: 'none',
	url: '',
	title: "Don't miss out!",
	subtitle: 'Last days to grab amazing deals before the sale ends!',
	show_days: true,
	days_label: 'Days',
	show_hours: true,
	hours_label: 'Hours',
	show_minutes: true,
	minutes_label: 'Minutes',
	show_seconds: true,
	seconds_label: 'Seconds',
	button_text: 'Shop now!',
	font: 'arial',
	background_color: '#0C1839',
	timer_window_color: '#172B61',
	timer_window_border_width: 0,
	timer_window_border_color: '#000000',
	timer_content_spacing_top: 0,
	timer_content_spacing_right: 0,
	timer_content_spacing_bottom: 0,
	timer_content_spacing_left: 0,
	timer_corner_radius_mode: CornerRadiusMode.ALL,
	timer_corner_radius_all: 0,
	timer_corner_radius_top_left: 0,
	timer_corner_radius_top_right: 0,
	timer_corner_radius_bottom_left: 0,
	timer_corner_radius_bottom_right: 0,
	countdown_color: '#D1FF53',
	time_units_color: '#A1B2D9',
	title_font_style: '24px bold #4FB0FF',
	subtitle_font_style: '16px italic #A1B2D9',
	button_bg_color: '#D1FF53',
	button_text_color: '16px bold #0C1839',
	timer_position: TimerPosition.TOP,
	sticky_timer: true,
	countdown_position: CountdownPosition.RIGHT_OF_TITLE,
	animation: AnimationEnum.FLIP,
	text_alignment: TextAlignment.LEFT,
	background_type: BackgroundType.COLOR,
	background_image: null,
	original_image_name: null,
	timer_mode: TimerMode.HIDE,
	message_text: 'Oops! This offer has ended. Maybe next time!',
	specificPages: [],
	categories: [],
	products: [],
	custom_css: '',
	mobile_use_desktop_settings: true,
	mobile_appearance: null,
};
